import { useSyncExternalStore } from 'react';
import { seja, type StanjeSeje } from './seja';

/** Trenutno stanje seje; komponenta se ob prijavi/odjavi ponovno izriše. */
export function useSeja(): StanjeSeje {
  return useSyncExternalStore(seja.naroci, seja.dobi);
}
